import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardHeader, FormControlLabel, Unstable_Grid2 as Grid, Icon, InputAdornment, LinearProgress, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Switch, TextField, Typography } from "@mui/material";
import { Clear, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { BuildJobInfo, JobType } from "../../../data/interfaces/jobmodels";
import BuildJob from "./buildjob";
import jobService from "../../../data/api/job.service";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";
import { JobTask } from "../../../data/interfaces/tablegenmodels";
import { ReleaseTableContext } from "./releasemain";


export default function ReleaseStatus() {
    const { setIsCreateJob } = useContext(ReleaseTableContext);
    const [releasejobs, setReleaseJobs] = useState<BuildJobInfo[]>([]);
    const [selectedJob, setSelectedJob] = useState<BuildJobInfo | null>(null);
    const [periods, setPeriods] = useState<DropdownModel[]>([]);
    const [statuses, setStatuses] = useState<DropdownModel[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<string | null>("-99");
    const [selectedPeriod, setSelectedPeriod] = useState<string | null>("1");
    const [onlyMyjobs,setOnlyMyjobs]=useState<boolean>(false);
    const [tasks, setTasks] = useState<JobTask[]>([]);
    const [jobNumber, setJobNumber] = useState<string | null>(null);
    const [needRefresh,setNeedRefresh]=useState<boolean>(false);
    var refreshId: number | NodeJS.Timeout | string | undefined;
    useEffect(() => {
        jobService.getJobStatuses().then((response) => {
            setStatuses(response.data);
        });
        jobService.getFilterTimePeriods().then((response) => {
            setPeriods(response.data);
        });

    }, []);

    useEffect(() => {
        if (periods.length > 0) {
            setSelectedPeriod(periods[0].Id);
        }
    }, [periods]);

    useEffect(()=>{
        if(!needRefresh){
            if(!refreshId)clearInterval(refreshId);
            return;
        }
        refreshId = setInterval(updateStatus, 5000);
        return () => clearInterval(refreshId);
    },[needRefresh]);
    const updateStatus=()=>{
        updateJobs();
    }

    useEffect(() => {
        updateJobs();
    }, [selectedStatus, selectedPeriod, jobNumber,onlyMyjobs]);

    useEffect(() => {
        // if (releasejobs.length > 0 && selectedJob == undefined) {
        //     setSelectedJob(releasejobs[0]);
        // }
        setNeedRefresh(releasejobs.findIndex(a=>a.Progress<100)>-1);
    }, [releasejobs]);

    useEffect(() => {
        if (selectedJob && tasks.findIndex(a => a.JobId == selectedJob.Id) < 0) {
            refreshTasks();
        }
    }, [selectedJob]);

    const refreshTasks=()=>{
        if(needRefresh){
            jobService.getTasksBg(selectedJob?.Id ?? 0).then((reponse) => {
                let tempTasks = [];
                if (reponse.data) {
                    for (var i = 0; i < reponse.data.length; i++) {
                        var task = reponse.data[i];
                        if (tempTasks.findIndex(a => a.Id == task.Id) < 0)
                            tempTasks.push(task);
                    }
    
                    setTasks(tempTasks);
                }
            });
        }
        else{
        jobService.getTasks(selectedJob?.Id ?? 0).then((reponse) => {
            let tempTasks = [];
            if (reponse.data) {
                for (var i = 0; i < reponse.data.length; i++) {
                    var task = reponse.data[i];
                    if (tempTasks.findIndex(a => a.Id == task.Id) < 0)
                        tempTasks.push(task);
                }

                setTasks(tempTasks);
            }
        });
    }
    }

    const updateJobs = () => {
        if(needRefresh){
            if (selectedPeriod && selectedStatus) {
                jobService.getJobsBg(true, JobType.Release, selectedPeriod, selectedStatus, jobNumber,onlyMyjobs).then((response) => {
                    setReleaseJobs(response.data);
                });
            }
        }
        else{
        if (selectedPeriod && selectedStatus) {
            jobService.getJobs(true, JobType.Release, selectedPeriod, selectedStatus, jobNumber,onlyMyjobs).then((response) => {
                setReleaseJobs(response.data);
            });
        }
    }
    }
    const handleListItemClick = (
        event: React.SyntheticEvent,
        expanded: boolean,
        job: BuildJobInfo,
    ) => {
        if (selectedJob?.Id != job.Id)
            setSelectedJob(job);



    };

    const refresh = () => {
        updateJobs();
        //refreshTasks();
    }

    const handleShowLogs=(job: BuildJobInfo)=> {
        if(job.Id==selectedJob?.Id)
            setSelectedJob(null);
        else
            setSelectedJob(job);

    }

    const ReleaseTableHeader = () => {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">Release Jobs</Typography>
                <Button variant="contained" onClick={() => setIsCreateJob(true)}>Create Release</Button>
                <Button variant="outlined" onClick={refresh}>Refresh</Button>
            </Box>
        )
    }

    return (
        <Grid container spacing={1}>
            <Grid xs={selectedJob? 6:12}>
                <Card>
                    <CardHeader title={<ReleaseTableHeader />} sx={{ color: "primary.main" }} />
                    <CardContent>
                        <Grid container spacing={2} sx={{ mb: 1 }}>
                            <Grid xs={6}>
                                <TextField onChange={(event) => { setJobNumber(event.target.value) }} placeholder="Search Job Number" size="small" sx={{ width: '100%' }} variant="standard"
                                />
                            </Grid>
                            <Grid xs={6}  >
                                <Select label='Select Time Period' sx={{ width: '100%' }} size="small" value={selectedPeriod}
                                    onChange={(event) => { setSelectedPeriod(event.target.value) }}>
                                    {
                                        periods.map((period) => {
                                            return (
                                                <MenuItem key={period.Id} value={period.Id} >{period.Description}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Grid>
                            <Grid xs={6}>
                                <FormControlLabel control={<Switch value={onlyMyjobs} onChange={(event, value) => { setOnlyMyjobs(value) }} />} label="My Jobs" sx={{ width: '100%' }} />
                            </Grid>
                            <Grid xs={6}>
                                <Select label='Select Status' sx={{ width: '100%' }} size="small" value={selectedStatus}
                                    onChange={(event) => { setSelectedStatus(event.target.value) }}>
                                    <MenuItem key={-99} value={-99} >All</MenuItem>
                                    {
                                        statuses.map((status) => {
                                            return (
                                                <MenuItem key={status.Id} value={status.Id} >{status.Description}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </Grid>
                        </Grid>
                        <List>
                            {releasejobs.map((job) => {
                                return (
                                    <Accordion key={job.Id} onChange={(event, expanded) => handleListItemClick(event, expanded, job)} >
                                        <AccordionSummary
                                            aria-controls={job.JobNumber + "-content"}
                                            id={job.JobNumber + "-header"}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    //width:'10px',
                                                    justifyContent: 'center',
                                                    color: 'primary.main'
                                                }}>
                                                <Icon>{job.TicketType == 'Magnetic' ? 'credit_card' : 'train'}</Icon>
                                            </ListItemIcon>
                                            <Box sx={{ display: 'inline-grid', width: '35%', flexShrink: 0 }}>
                                                <Typography sx={{ fontWeight: 'bold' }}>
                                                    {job.JobNumber}
                                                </Typography>
                                                <Typography >
                                                    {job.CreatedDate}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'inline-grid', width: '57%' }}>
                                                <Typography sx={{ color: 'text.secondary' }}>{job.Status}</Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Box sx={{ width: '100%', mr: 1 }}>
                                                        <LinearProgress variant="determinate" value={job.Progress} valueBuffer={100} />
                                                    </Box>
                                                    <Box sx={{ minWidth: 35 }}>
                                                        <Typography variant="body2" color="text.secondary">{`${Math.round(
                                                            job.Progress,
                                                        )}%`}</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Button sx={{ml:1}} variant="outlined" disabled={job.Progress!=100} onClick={()=>handleShowLogs(job)}>{job.Id==selectedJob?.Id?'Hide Details':'Show Details'} </Button>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List>
                                                {tasks.filter(j => j.JobId == job.Id).map((task) => {
                                                    return (
                                                        <ListItem key={task.Id} component={Paper}>
                                                            <ListItemText>{task.Nlc ?? "Global"}</ListItemText>
                                                            <ListItemText>{task.Table}</ListItemText>
                                                            <ListItemText>{task.Status}</ListItemText>
                                                        </ListItem>
                                                    )
                                                })

                                                }
                                            </List>
                                        </AccordionDetails>
                                    </Accordion>

                                )
                            })

                            }
                        </List>
                    </CardContent>
                </Card>
            </Grid>
           {selectedJob? <Grid xs={6}>
                <BuildJob job={selectedJob} needRefresh={false}/>
            </Grid>:null}
        </Grid>

    )
}